document.addEventListener('DOMContentLoaded', () => {

    function setupQuantityButtons() {
        const qtyInput = document.getElementById('quantity');
        const qtyDecrease = document.querySelector('.new-pdp-hero__qty-decrease');
        const qtyIncrease = document.querySelector('.new-pdp-hero__qty-increase');
        const qtyErrorMessage = document.querySelector('.new-pdp-hero__error_message');

        qtyDecrease.addEventListener('click', function () {
            let currentValue = parseInt(qtyInput.value);
            let minValue = parseInt(qtyInput.min);

            if (currentValue > minValue) {
                qtyInput.value = currentValue - 1;
                qtyErrorMessage.style.opacity = 0;
            } else {
                qtyErrorMessage.style.opacity = 1;
                setTimeout(() => {
                    qtyErrorMessage.style.opacity = 0;
                }, 1500)
            }

            updatePrice()
        });

        qtyIncrease.addEventListener('click', function () {
            let currentValue = parseInt(qtyInput.value);
            qtyInput.value = currentValue + 1;
            qtyErrorMessage.style.opacity = 0;
            updatePrice()
        });
    }

    setupQuantityButtons();

    function updatePrice() {
        const quantityInput = document.querySelector('[id="quantity"]');
        const priceElement = document.querySelector('.new-pdp-hero__button-price');

        if (!quantityInput || !priceElement) return;

        const quantity = parseInt(quantityInput.value, 10);
        const priceFormat = priceElement.dataset.priceFormat || 'money';

        function extractNumber(priceString) {
            return parseFloat(priceString.replace(/[^0-9.]/g, ''));
        }

        const basePrice = extractNumber(priceElement.dataset.price || priceElement.textContent);

        const newPrice = basePrice * quantity;

        let formattedPrice;
        if (priceFormat === 'money_without_trailing_zeros') {
            formattedPrice = `$${newPrice % 1 === 0 ? newPrice.toFixed(0) : newPrice.toFixed(2)}`;
        } else {
            formattedPrice = `$${newPrice.toFixed(2)}`;
        }

        priceElement.textContent = formattedPrice;
    }

    updatePrice()


    // Slick slider init
    const $navSlider = $('.new-pdp-hero__list-img');
    const $mainSlider = $('.new-pdp-hero__main-img--desktop');
    const slidesToShow = 5;
    const sliderSpeed = $('.new-pdp-hero__main-img--desktop').data('slider-speed') ? $('.new-pdp-hero__main-img--desktop').data('slider-speed') : 10000;

    $mainSlider.slick({
        slidesToShow: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: sliderSpeed,
        prevArrow: '<button type="button" class="new-pdp-hero__arrow new-pdp-hero__arrow-prev"></button>',
        nextArrow: '<button type="button" class="new-pdp-hero__arrow new-pdp-hero__arrow-next"></button>',
        fade: true,
        asNavFor: $navSlider
    });
    $navSlider.slick({
        centerMode: false,
        centerPadding: '0',
        slidesToShow: slidesToShow,
        slidesToScroll: 5,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        swipeToSlide: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: $mainSlider
    });

    function updateSliderOptions() {
        const slideCount = $navSlider.slick('getSlick').slideCount;
        const slidesToScrollSetting = slideCount <= slidesToShow ? slidesToShow : 1;
        const infiniteSetting = slideCount > slidesToShow;
        const swipeToSlideSetting = slideCount > slidesToShow;

        $navSlider.slick('slickSetOption', 'infinite', infiniteSetting, true);
        $navSlider.slick('slickSetOption', 'swipeToSlide', swipeToSlideSetting, true);
        $navSlider.slick('slickSetOption', 'slidesToScroll', slidesToScrollSetting, true);
    }

    updateSliderOptions();

    $navSlider.on('init', function () {
        updateSliderOptions();
    });


    $('.new-pdp-hero__main-img--mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: sliderSpeed,
        arrows: false,
        dots: true,
        dotsClass: 'new-pdp-hero__dots',
        adaptiveHeight: true,
        centerMode: true,
        fade: true
    });

    function initializeModal() {
        const modal = document.getElementById("modal");
        const modalWrapper = document.getElementById("modalWrapper");
        const closeButton = document.getElementById("closeButton");
        const triggerButton = document.querySelector(".new-pdp-hero-bottom-info__link");
        const mainTriggerButton = document.querySelector(".new-pdp-hero__modal-btn");

        function openModal(e) {
            e.preventDefault;
            modal.style.display = "block";
        }

        function closeModal() {
            modal.style.display = "none";
        }

        closeButton.addEventListener("click", closeModal);

        window.addEventListener("click", function (event) {
            if (event.target === modalWrapper) {
                closeModal();
            }
        });

        if (triggerButton) {
            triggerButton.addEventListener("click", openModal);
        }

        if (mainTriggerButton) {
            mainTriggerButton.addEventListener("click", openModal);
        }
    }

    initializeModal();

    function initializeVariantButtons() {
        const variantButtons = document.querySelectorAll('.new-pdp-hero__variant-button');
        const selectedVariantInput = document.querySelector('.new-pdp-hero__selected-variant');
        const priceElement = document.querySelector('.new-pdp-hero__button-price');
        const heroPriceElement = document.querySelector('.new-pdp-hero__price');

        variantButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                variantButtons.forEach(function (btn) {
                    btn.classList.remove('is-active');
                });

                this.classList.add('is-active');
                selectedVariantInput.value = this.dataset.variantId;

                if (priceElement) {
                    const buttonPrice = this.dataset.buttonPrice || this.dataset.price;
                    priceElement.innerText = buttonPrice;
                    priceElement.dataset.price = buttonPrice;
                }

                if (heroPriceElement) {
                    heroPriceElement.innerText = this.dataset.price;
                }

                updatePrice()
            });
        });
    }
    function initializeVariantSelect() {
        const select = document.querySelector('.new-pdp-hero__variant-select');
        const selectedVariantInput = document.querySelector('.new-pdp-hero__selected-variant');
        const priceElement = document.querySelector('.new-pdp-hero__button-price');
        const heroPriceElement = document.querySelector('.new-pdp-hero__price');

        select.addEventListener('change', function () {
            const selectedOption = select.options[select.selectedIndex];
            const variantId = selectedOption.value;
            const price = selectedOption.dataset.price;
            const buttonPrice = selectedOption.dataset.buttonPrice || price;

            selectedVariantInput.value = variantId;

            if (priceElement) {
                priceElement.innerText = buttonPrice;
                priceElement.dataset.price = buttonPrice;
            }

            if (heroPriceElement) {
                heroPriceElement.innerText = price;
            }

            updatePrice();
        });
    }

    initializeVariantButtons();
    initializeVariantSelect();
});